import React from "react";
import {
  GOVGR_BTN_CUSTOMCOLOR,
  GOVGR_BTN_SECONDARY_CUSTOM_COLOR,
  GOVGR_DROPDOWN__CONTENT,
  GOVGR_LINK,
  GOVGR_SVG_ICON,
  GOVGR_SVG_ICON__MORE_VERT,
  GOVGR_VERTICAL_NAV,
  GOVGR_VERTICAL_NAV_ITEM,
  GOV_GR_DROPDOWN,
} from "../../conf/styles/GovGrDrawerMenu";
import "./index.css";

const DropDownMenu = ({ dropdownoptions }) => {
  return (
    <details className={`${GOV_GR_DROPDOWN} p-0`}>
      <summary
        className={`${GOVGR_BTN_CUSTOMCOLOR} ${GOVGR_BTN_SECONDARY_CUSTOM_COLOR}`}
      >
        <svg
          aria-hidden="true"
          className={`${GOVGR_SVG_ICON} ${GOVGR_SVG_ICON__MORE_VERT}`}
          focusable="false"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </summary>
      <div className={`${GOVGR_DROPDOWN__CONTENT} right-1`}>
        {dropdownoptions ? (
          <nav className={`${GOVGR_VERTICAL_NAV}`}>
            {dropdownoptions.map((item, index) => (
              <span
                onClick={item.onClick}
                className={`${GOVGR_LINK} ${GOVGR_VERTICAL_NAV_ITEM}`}
                key={index}
              >
                {item.text}
              </span>
            ))}
          </nav>
        ) : (
          <nav className={`${GOVGR_VERTICAL_NAV}`}>
            <a href="#" className={`${GOVGR_LINK} ${GOVGR_VERTICAL_NAV_ITEM}`}>
              Επεξεργασία
            </a>
            <a href="#" className={`${GOVGR_LINK} ${GOVGR_VERTICAL_NAV_ITEM}`}>
              Μετακίνηση
            </a>
            <a href="#" className={`${GOVGR_LINK} ${GOVGR_VERTICAL_NAV_ITEM}`}>
              Οριστική διαγραφή
            </a>
          </nav>
        )}
      </div>
    </details>
  );
};

export default DropDownMenu;
